(function (angular) {
  "use strict";
  angular.module("Toyota.Services").service("ParseBool", function () {
    return function (value, fallback) {
      if (typeof value === "undefined" || value.toLowerCase() === "false" || value === "" || value === null) {
        return false;
      }

      if (value.toLowerCase() === "true") {
        return true;
      }

      return fallback;
    };
  });
})(window.angular);
